import React, { Component, createRef } from "react";
import "./styles.css";
import { Link } from "react-router-dom";
import { routePrefix } from "../../config";
import backArrow from "../../images/dayViewBackArrow.svg";
import { connect } from "react-redux";
import * as actions from "../../containers/inventoryView/actions";
import moment from "moment";
import refresh from "../../images/refresh.svg";
import downloadIcon from "../../images/download.svg";
import TablePagination from "../../components/common/tablePagination";
import RadioButton from "../../components/common/radioButton";
import downArrow from "../../images/downArrowDropDown.svg";
import searchIcon from "../../images/search.svg";
import searchAbort from "../../images/searchClose.svg";
import upArrow from "../../images/upArrow.svg";
import InPageCalendar from "./inPageCalendar";

class DayLevelView extends Component {
  constructor(props) {
    super(props);
    this.myRef = createRef();
    this.state = {
      pageNum: 1,
      noOfEntries: 50,
      showEntriesOption: false,
      servicesFilter: "All Services",
      showServiceFiltersList: false,
      searchQueryRoutes: [],
      queryInput: "",
      showInPageCalendar: false,
      viaRoutesCheckbox: false,
    };

    this.searchQuery = this.searchQuery.bind(this);
    this.inputCleared = true;
  }

  componentDidMount() {
    window.scrollTo({ top: 0, behavior: "smooth" });
    const date = localStorage.getItem("selected-date");
    this.props.fetchInventoryRouteLevelView(date);
    this.focusInput();
  }

  onPageRedirection = (e, route, route_id) => {
    e.stopPropagation();
    localStorage.setItem("selected-route", route);
    localStorage.setItem("route-id", route_id);
  };

  focusInput = () => {
    if (this.inputFocus) {
      this.inputFocus.focus();
    }
  };

  onPrevClick = () => {
    this.myRef.current.scrollIntoView();
    this.setState({ pageNum: this.state.pageNum - 1 });
  };

  onNextClick = () => {
    this.myRef.current.scrollIntoView();
    const PaginationLimit = this.state.noOfEntries;
    // if page data is available just increase the page num count
    const routeData =
      this.props.inventoryRouteLevelData &&
      this.props.inventoryRouteLevelData.routeData;
    if (routeData && routeData.length > this.state.pageNum * PaginationLimit) {
      this.setState({ pageNum: this.state.pageNum + 1 });
      return;
    }
  };

  onPageNumClick = (page) => {
    this.setState({ pageNum: page });
  };

  isShowRejectedData = () => {
    if (this.state.servicesFilter === "Rejected Services") {
      return true;
    }
    return false;
  };

  getRouteData = () => {
    const { inventoryRouteLevelData } = this.props;
    const { queryInput, searchQueryRoutes } = this.state;
    const rejectedServies = [];
    if (queryInput.length > 0) {
      if (this.isShowRejectedData()) {
        searchQueryRoutes &&
          searchQueryRoutes.map((item) => {
            if (item.rejected >= 1) {
              rejectedServies.push(item);
            }
          });
        return rejectedServies;
      } else return searchQueryRoutes && searchQueryRoutes;
    }
    if (this.isShowRejectedData()) {
      inventoryRouteLevelData &&
        inventoryRouteLevelData.routeData.map((item) => {
          if (item.rejected >= 1) {
            rejectedServies.push(item);
          }
        });
      return rejectedServies;
    } else return inventoryRouteLevelData && inventoryRouteLevelData.routeData;
  };

  refreshRoute = (routeId) => {
    const citiyIDs = routeId.split("-");
    const sourceID = citiyIDs[0];
    const destinationId = citiyIDs[1];
    this.props.inventoryRouteLevelRefresh({
      source_id: sourceID.toString(),
      destination_id: destinationId.toString(),
      date: moment().format("YYYY-MM-DD"),
    });
    setTimeout(function () {
      window.location.reload();
    }, 1000);
  };

  downloadFile = (routeId, route) => {
    const citiyIDs = routeId.split("-");
    const sourceID = citiyIDs[0];
    const destinationId = citiyIDs[1];
    const date = localStorage.getItem("selected-date");
    const providerId = JSON.parse(localStorage.getItem('provider-id'));
    const operatorId = JSON.parse(localStorage.getItem('operator-id'));
    let paramsObj = [];
    paramsObj.srcId = sourceID;
    paramsObj.destId= destinationId;
    paramsObj.route = route;
    paramsObj.date = date;
    paramsObj.pid=providerId;
    paramsObj.oid=operatorId;
    this.props.downloadCSV('routelevel', paramsObj);
  };

  renderRefresButton = (item) => {
    let download_support = JSON.parse(localStorage.getItem('download-support'));
    return (
      <>
        <div
          className="refreshButton"
          onClick={() => this.refreshRoute(item.paytm_route_id)}
        >
          <img src={refresh} alt="refresh-icon" />
          <span className="refreshText">Refresh</span>
        </div>
        {
          download_support && 
          <div
          className="refreshButton"
          onClick={() => this.downloadFile(item.paytm_route_id, item.route_name)}
        >
          <img src={downloadIcon} alt="refresh-icon" />
          <span className="refreshText">Download</span>
        </div>
        }
        
      </>
    );
  };

  hightLightText = (str, val) => {
    const index = str.toLowerCase().indexOf(val.toLowerCase());
    if (index > 0) {
      return [
        str.substring(0, index),
        <b key={1} style={{ color: "#000" }}>
          {val}
        </b>,
        str.substring(index + val.length),
      ];
    }
    if (index === 0) {
      return [
        <b key={1} style={{ color: "#000" }}>
          {str.substring(0, index + val.length)}
        </b>,
        str.substring(index + val.length),
      ];
    }
    return str;
  };

  onEntryCountChange = (value) => {
    if (value === 50) this.setState({ noOfEntries: 50 });
    if (value === 75) this.setState({ noOfEntries: 75 });
    else if (value === 100) this.setState({ noOfEntries: 100 });
    this.setState({ showEntriesOption: false, pageNum: 1 });
  };

  onServicesFilterChange = (service) => {
    if (service === "All Services")
      this.setState({ servicesFilter: "All Services" });
    else if (service === "Rejected Services")
      this.setState({ servicesFilter: "Rejected Services" });
    this.setState({ showServiceFiltersList: false });
  };

  searchQuery(e) {
    const { inventoryRouteLevelData } = this.props;
    const routesData =
      inventoryRouteLevelData && inventoryRouteLevelData.routeData;
    const routesToDisplay = [];
    const { value } = e.target;
    const givenInput = value && value.split(" ").join("");
    if (e.key === "Backspace" && this.inputCleared && givenInput.length === 0) {
      this.inputCleared = false;
    }
    this.setState({ queryInput: givenInput });
    if (givenInput.length > 0) {
      this.setState({ pageNum: 1 });
      this.inputCleared = true;
      routesData.map((item) => {
        if (item.route_name.toLowerCase().includes(givenInput.toLowerCase())) {
          routesToDisplay.push(item);
        }
      });
    }
    this.setState({ searchQueryRoutes: routesToDisplay });
  }

  showEntriesDropdown = () => {
    this.setState({ showEntriesOption: !this.state.showEntriesOption });
  };

  showServicesFiltersDropdown = () => {
    this.setState({
      showServiceFiltersList: !this.state.showServiceFiltersList,
    });
  };

  abortSearch = () => {
    this.inputFocus.value = "";
    this.setState({ queryInput: "" });
  };

  renderInPageCalendar = () => {
    this.setState({ pageNum: 1 });
    this.setState({ showInPageCalendar: !this.state.showInPageCalendar });
  };

  onViaRoutesCheckBox = () => {
    const date = localStorage.getItem("selected-date");
    if (date) {
      this.props.fetchInventoryRouteLevelView(
        date,
        !this.state.viaRoutesCheckbox
      );
      this.setState({ viaRoutesCheckbox: !this.state.viaRoutesCheckbox });
    }
  };

  render() {
    const paginationLimit = this.state.noOfEntries;
    const routeData = this.getRouteData();
    let startIndex = (this.state.pageNum - 1) * paginationLimit;
    let endIndex = this.state.pageNum * paginationLimit;
    const date = localStorage.getItem("selected-date");
    const entries = [50, 75, 100];
    const servicesFiltersList = ["All Services", "Rejected Services"];
    const { queryInput } = this.state;
    let via_route_support =
      JSON.parse(localStorage.getItem("via-routes-support")) ||
      this.props.allRoutesInfo.via_route_support;

    return (
      <div className="dayLevelContainer" ref={this.myRef}>
        <div className="dayLevelViewHeader">
          <div className="headerLhs">
            <Link to={routePrefix + "/inventory-view"}>
              <img className="backIcon" src={backArrow} alt="icon" />
            </Link>
            <div className="headerDate">
              <span className="headerTextDayView">
                {moment(date).format("dddd, MMMM DD, yyyy")}
              </span>
              {this.state.showInPageCalendar === false && (
                <img
                  className="downArrow"
                  src={downArrow}
                  alt="icon"
                  onClick={this.renderInPageCalendar}
                />
              )}
            </div>
          </div>
          <div className="search">
            <img className="searchIcon" src={searchIcon} alt="search"></img>
            <input
              className="searchInput"
              type="text"
              ref={(c) => {
                this.inputFocus = c;
              }}
              placeholder={"Search Route"}
              onKeyUp={this.searchQuery}
            />
            {queryInput.length > 0 ? (
              <img
                className="searchClose"
                src={searchAbort}
                alt="searchAbort"
                onClick={this.abortSearch}
              ></img>
            ) : (
              <span className="searchClose"></span>
            )}
          </div>
          <div className="filters">
            {via_route_support && (
              <div className="checkbox">
                <input
                  type="checkbox"
                  id="inventory_refresh_checkbox"
                  checked={this.state.viaRoutesCheckbox}
                  onClick={this.onViaRoutesCheckBox}
                />
                <label onClick={this.onViaRoutesCheckBox} className="checkbox">
                  Include via routes
                </label>
              </div>
            )}
            <div className="serviceFilters">
              <div className="filterHeader">FILTER BY</div>
              <div
                className="entriesNumber"
                onClick={this.showServicesFiltersDropdown}
              >
                <div className="headerRHS">{this.state.servicesFilter}</div>
                <img
                  className="downArrow"
                  src={downArrow}
                  alt="downArrow"
                ></img>
              </div>

              {this.state.showServiceFiltersList && (
                <div className="filterOptionsContainer">
                  <span>
                    <img className="upArrow" src={upArrow} alt="icon" />
                  </span>
                  <div className="filtersList">
                    {servicesFiltersList.map((item, index) => (
                      <div key={index}>
                        <div className="radio">
                          <RadioButton
                            label={item}
                            isChecked={this.state.servicesFilter === item}
                            onSelectionChange={() => {
                              this.onServicesFilterChange(item);
                            }}
                          />
                        </div>
                        {item === "All Services" && (
                          <div className="bottomLine"></div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="tableContainer">
          <table className="app-table">
            <thead>
              <tr className="payout-table-header">
                <th>Route</th>
                <th>Service Count</th>
                <th>
                  <div>
                    <p>Rejected Service Count</p>
                    <p className="note">(NOTE: Tap to see the reasons)</p>
                  </div>
                </th>
                <th>Last Refreshed</th>
                <th className="action-th">Action</th>
              </tr>
            </thead>
            <tbody>
              {(!routeData || !routeData.length) && (
                <tr>
                  <td colSpan={9} className="table-no-data">
                    No Data Found
                  </td>
                </tr>
              )}
              {routeData &&
                routeData.slice(startIndex, endIndex).map((el, i) => (
                  <tr key={i} className="payout-table-row">
                    <td>
                      {queryInput.length > 0
                        ? this.hightLightText(el.route_name, queryInput)
                        : el.route_name}
                    </td>
                    <td className="servicesCount">{el.services}</td>
                    <td>
                      <Link
                        to={routePrefix + "/inventory-view/reasons"}
                        className="rejectedCount"
                        onClick={(e) => {
                          this.onPageRedirection(
                            e,
                            el.route_name,
                            el.paytm_route_id
                          );
                        }}
                      >
                        {el.rejected}
                      </Link>
                    </td>
                    <td>
                      {moment(el.last_updated).format("ddd, MMM Do, h:mm a")}
                    </td>
                    <td className="refreshButtonTd">
                      {this.renderRefresButton(el)}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
          {routeData && Boolean(routeData.length) && (
            <div className="pagination">
              <div className="numberOfEntriesFilter">
                <div className="filterHeader">SHOW RESULTS</div>
                <div
                  className="entriesNumber"
                  onClick={this.showEntriesDropdown}
                >
                  <div className="headerRHS">{`${this.state.noOfEntries} per Page`}</div>
                  <img
                    className="downArrow"
                    src={downArrow}
                    alt="downArrow"
                  ></img>
                </div>
                {this.state.showEntriesOption && (
                  <div className="entriesListContainer">
                    <span>
                      <img
                        className="upArrowEntries"
                        src={upArrow}
                        alt="icon"
                      />
                    </span>
                    <div className="entriesList">
                      {entries.map((item, index) => (
                        <div key={index}>
                          <div className="radio">
                            <RadioButton
                              label={`${item} per Page`}
                              isChecked={this.state.noOfEntries === item}
                              onSelectionChange={() => {
                                this.onEntryCountChange(item);
                              }}
                            />
                          </div>
                          {(item === 50 || item === 75) && (
                            <div className="bottomLine"></div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
              <TablePagination
                pageNum={this.state.pageNum}
                dataLength={routeData && routeData.length}
                onPrevClick={this.onPrevClick}
                onNextClick={this.onNextClick}
                onPageNumClick={this.onPageNumClick}
                isInventoryView={true}
                paginationLimit={paginationLimit}
              />
            </div>
          )}
        </div>
        {this.state.showInPageCalendar ? (
          <div className="calendarContainer">
            <InPageCalendar renderInPageCalendar={this.renderInPageCalendar} />
          </div>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (store) => ({
  inventoryRouteLevelData: store.inventoryViewReducer.inventoryRouteLevelData,
  inventoryRouteLevelRefreshData:
    store.inventoryViewReducer.inventoryRouteLevelRefreshData,
  allRoutesInfo: store.userInfoReducer.allRoutesInfo,
});

const mapDispatchToProps = (dispatch) => ({
  fetchInventoryRouteLevelView: (date, isViaRoutes) =>
    dispatch(actions.fetchInventoryRouteLevelView(date, isViaRoutes)),
  inventoryRouteLevelRefresh: (query) =>
    dispatch(actions.inventoryRouteLevelRefresh(query)),
  downloadCSV : (source, paramsObj) => 
    dispatch(actions.downloadCSV(source, paramsObj)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DayLevelView);
